import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable()
export class ConfigService {

    constructor() {

    }

    public get(key: String) {
        return environment[key.toString()];
    }

}
